import { ClassScheduleView } from "../schedule/ClassScheduleView";
import { primarySchedule } from "../schedule/data";

export const RaspisanieChild = () => <ClassScheduleView schedule={primarySchedule} />;
